import { render, staticRenderFns } from "./PromotionalCard.vue?vue&type=template&id=009ad1fc&scoped=true"
import script from "./PromotionalCard.vue?vue&type=script&lang=js"
export * from "./PromotionalCard.vue?vue&type=script&lang=js"
import style0 from "./PromotionalCard.vue?vue&type=style&index=0&id=009ad1fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009ad1fc",
  null
  
)

export default component.exports